import { render } from "./pointUse.vue?vue&type=template&id=002ec5c0&scoped=true"
import script from "./pointUse.vue?vue&type=script&lang=js"
export * from "./pointUse.vue?vue&type=script&lang=js"

import "./pointUse.vue?vue&type=style&index=0&id=002ec5c0&scoped=true&lang=css"
import "@/styles/striNew.css?vue&type=style&index=1&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/tcd-partnerpage-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002ec5c0"]])

export default __exports__